export default __webpack_public_path__ + "static/media/casaduana_gps.edada914.svg";